const containerStack = {
  padding: {
    xs: '0 2rem 2rem 2rem',
    m: '0 4rem 2rem 4rem',
    md: '0 6rem 2rem 6rem',
  },
  alignSelf: 'stretch',
  background: 'radial-gradient(ellipse 60% 40% at 50% 50%, rgba(230, 46, 102, 0.18) 0%, rgba(230, 46, 102, 0.00) 100%)',
};

const contentStack = {
  width: '100%',
  maxWidth: '80rem',
  gap: '4.3rem',
  flex: '1 0 0',
};

const headerSection = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: { xs: '2.5rem', md: '5rem' },
  alignSelf: 'stretch',
};

const titleContainer = {
  justifyContent: 'flex-start',
  paddingTop: '5rem',
  gap: '1.1rem',
};

const titleTypography = (theme) => ({
  color: theme.palette.neutral.A700,
  fontSize: { xs: '2rem', sm: '2.5rem' },
});

const descriptionTypography = (theme) => ({
  color: theme.palette.neutral.A500,
  whiteSpace: 'pre-line',
  fontSize: { xs: '1rem', sm: '1.125rem' },
});

const commentIcon = {
  width: '1.75rem',
  height: '1.75rem',
  objectFit: 'cover',
  alignSelf: 'flex-start',
};

const commentTypography = (theme) => ({
  color: theme.palette.neutral.A500,
  fontStyle: 'italic',
  fontSize: { xs: '1rem', sm: '1.125rem' },
});

const videoCard = (widthCardAnimation, isLastVideo) => ({
  display: 'flex',
  flexDirection: 'row',
  width: `${widthCardAnimation}rem`,
  height: '22rem',
  borderRadius: '1.5rem',
  overflow: 'hidden',
  marginRight: isLastVideo ? '0' : '2rem',
});

const videoStyles = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
};

const missionVisionContainer = {
  padding: '2rem 1.5rem 5rem 1.5rem',
  gap: '0.625rem',
  alignSelf: 'stretch',
};

const missionVisionStack = {
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'row' },
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: { xs: '3rem', phone: '5rem', lg: '8rem' },
  flex: '1 0 0',
};

const missionVisionItem = {
  display: 'flex',
  flexDirection: 'column',
  width: { xs: '100%', sm: '50%' },
  gap: '0.625rem',
};

const missionVisionTitleTypography = (theme) => ({
  color: theme.palette.neutral.A700,
  fontSize: { xs: '2rem', sm: '2.5rem' },
});

const missionVisionTextTypography = (theme) => ({
  color: theme.palette.neutral.A500,
  whiteSpace: 'pre-line',
  textAlign: { xs: 'justify', md: 'left' },
  fontSize: { xs: '1.1rem', sm: '1.125rem' },
});

export {
  containerStack,
  contentStack,
  headerSection,
  titleContainer,
  titleTypography,
  descriptionTypography,
  commentIcon,
  commentTypography,
  videoCard,
  videoStyles,
  missionVisionContainer,
  missionVisionStack,
  missionVisionItem,
  missionVisionTitleTypography,
  missionVisionTextTypography,
};
